import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {WagmiConfig,configureChains, createConfig} from 'wagmi'
import { polygon } from '@wagmi/core/chains'
import {EthereumClient,w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { publicProvider } from 'wagmi/providers/public'
import { Web3Modal } from '@web3modal/react'

const chainOptions = [polygon];
//const projectId = '2f9b552c9acbb2c405cbbe66e21593fb';//dev testing
const projectId = '029ff3698e7b5ca9d52649acbd951344';

const connectors = w3mConnectors({
  projectId,
  chainOptions
});
const providers = [
  w3mProvider({ projectId }),
  publicProvider()
];
const { chains,publicClient,webSocketPublicClient  } = configureChains(
  chainOptions,
  providers,
  { stallTimeout: 2000 },
);

const wagmiConfig = createConfig({
  autoConnect: false,
  connectors: connectors,
  publicClient,
  webSocketPublicClient
});
const ethereumClient = new EthereumClient(wagmiConfig, chains);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WagmiConfig config={wagmiConfig}>
    <App />
    </WagmiConfig>
    <Web3Modal projectId={projectId} ethereumClient={ethereumClient} style={{display:"none"}} themeVariables={{
        '--w3m-font-family': 'Allerta',
        '--w3m-text-medium-regular-size':"18px",
        '--w3m-text-medium-regular-line-height':"120%",
        '--w3m-accent-color': '#1E1C1D',
        '--w3m-accent-fill-color':'#ffffff',
        '--w3m-background-color':'#ffffff',
        '--w3m-color-bg-1':"#000000",
        '--w3m-button-border-radius':'0px',
        '--w3m-logo-image-url':'https://static.wixstatic.com/media/a0044d_589a9089ad1446a39d189b00cae73f42~mv2.png/v1/crop/x_1829,y_812,w_1998,h_2198/fill/w_106,h_118,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/Transparent%20-%20RB%20Logo.png',
    }}
    explorerRecommendedWalletIds={[
      //metamask
      "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
      //phantom
      "a797aa35c0fadbfc1a53e7f675162ed5226968b44a19ee3d24385c64d1d3c393",
      //trust wallet
      "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0",
      //coinbase wallet
      "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa",
      //binance wallet
      "8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4",
      //safe wallet
      "225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f",

    ]}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
